<template>
   <i class="loader" v-if="show"></i>
</template>

<script>
export default {
   name: 'Loader',
   props: {
      show: Boolean
   }
};
</script>

<style lang="scss" src="./loader.scss"></style>
